import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _merge from 'lodash/merge';
import _set from 'lodash/set';
import _unset from 'lodash/unset';
export var DEFAULT_OPTIONS = {
  fallbackLng: [],
  load: 'languageOnly',
  lowerCaseLng: true,
  joinArrays: '\n',
  defaultNS: 'default',
  ns: [],
  interpolation: {
    escapeValue: false
  },
  detection: {
    order: ['cookie', 'navigator'],
    lookupCookie: 'lang',
    caches: ['cookie']
  }
};
export var normalizeOptions = function normalizeOptions(options) {
  var normalizedOptions = _objectSpread({}, options);

  var keyMap = {
    lang: 'lng',
    default: 'fallbackLng',
    cookie: 'detection.lookupCookie'
  };
  Object.keys(keyMap).forEach(function (key) {
    var destKey = keyMap[key];

    _unset(normalizedOptions, destKey);

    if (key in normalizedOptions) {
      _set(normalizedOptions, destKey, normalizedOptions[key]);

      delete normalizedOptions[key];
    }
  });
  normalizedOptions = _merge({}, DEFAULT_OPTIONS, normalizedOptions, {
    initImmediate: false
  });

  if (normalizedOptions.detection === false) {
    delete normalizedOptions.detection;
  }

  return normalizedOptions;
};
export var wrapCallback = function wrapCallback(fn, callback) {
  return new Promise(function (resolve, reject) {
    fn(function (err) {
      if (callback) {
        callback(err);
      }

      if (err) {
        reject(err);
        return;
      }

      resolve();
    });
  });
};